import request from '@/utils/request'

function fetchGetClickNumberByActivity(data) {
  return request({
    url: '/market/report/clientNumbers',
    method: 'get',
    params: data,
  })
}
function fetchGetNewRegistrationsByActivity(data) {
  return request({
    url: '/market/report/newRegistrations',
    method: 'get',
    params: data,
  })
}
function fetchGetNewTraderByActivity(data) {
  return request({
    url: '/market/report/firstTradesr',
    method: 'get',
    params: data,
  })
}
function fetchGetQualifiedTraderByActivity(data) {
  return request({
    url: '/market/report/accomplishTraders',
    method: 'get',
    params: data,
  })
}

export function fetchStatisticsOfActivity(data) {
  return Promise.all([
    fetchGetClickNumberByActivity(data),
    fetchGetNewRegistrationsByActivity(data),
    fetchGetNewTraderByActivity(data),
    fetchGetQualifiedTraderByActivity(data),
  ])
}

// 时间维度点击量、新增用户报表
export function fetchGetTrendChart1(data) {
  return request({
    url: '/market/statistics/clicknumstatistics',
    method: 'get',
    params: data,
  })
}

// 国家维度统计表
export function fetchGetTrendChart2(data) {
  return request({
    url: '/market/statistics/trendcountryReport',
    method: 'get',
    params: data,
  })
}

// CPA奖金报表
export function fetchGetCPABonusReport(data) {
  return request({
    url: '/market/report/cpaBonus',
    method: 'get',
    params: data,
  })
}

// CPA报表汇总
export function fetchGetCPABonusSum(data) {
  return request({
    url: '/market/report/sumCpaBonus',
    method: 'get',
    params: data,
  })
}
